import { expirioApi as api } from './expirioSlice';
const injectedRtkApi = api.injectEndpoints({
    endpoints: build => ({
        getVersion: build.query<GetVersionApiResponse, GetVersionApiArg>({
            query: () => ({ url: `/version` }),
        }),
        listSecrets: build.query<ListSecretsApiResponse, ListSecretsApiArg>({
            query: () => ({ url: `/api/secret` }),
        }),
        deleteSecret: build.mutation<DeleteSecretApiResponse, DeleteSecretApiArg>({
            query: queryArg => ({ url: `/api/secret/${queryArg.secretName}`, method: 'DELETE' }),
        }),
        createTextSecret: build.mutation<CreateTextSecretApiResponse, CreateTextSecretApiArg>({
            query: queryArg => ({ url: `/api/secret/text`, method: 'POST', body: queryArg.addTextSecretRequest }),
        }),
        readTextSecret: build.query<ReadTextSecretApiResponse, ReadTextSecretApiArg>({
            query: queryArg => ({ url: `/api/secret/text/${queryArg.secretName}` }),
        }),
        createFileSecret: build.mutation<CreateFileSecretApiResponse, CreateFileSecretApiArg>({
            query: queryArg => ({ url: `/api/secret/file`, method: 'POST', body: queryArg.addFileSecretRequest }),
        }),
        readFileSecret: build.query<ReadFileSecretApiResponse, ReadFileSecretApiArg>({
            query: queryArg => ({ url: `/api/secret/file/${queryArg.secretName}` }),
        }),
        readProviders: build.query<ReadProvidersApiResponse, ReadProvidersApiArg>({
            query: queryArg => ({ url: `/api/providers`, params: { State: queryArg.state } }),
        }),
        getAllProviderTokens: build.query<GetAllProviderTokensApiResponse, GetAllProviderTokensApiArg>({
            query: () => ({ url: `/api/providers/tokens` }),
        }),
        loginProvider: build.query<LoginProviderApiResponse, LoginProviderApiArg>({
            query: queryArg => ({
                url: `/api/auth/login/${queryArg.providerName}/${queryArg.tokenName}`,
                params: { asRedirect: queryArg.asRedirect },
            }),
        }),
        setProviderToken: build.mutation<SetProviderTokenApiResponse, SetProviderTokenApiArg>({
            query: queryArg => ({ url: `/api/auth/token`, method: 'POST', body: queryArg.setProviderTokenRequest }),
        }),
        getProviderToken: build.query<GetProviderTokenApiResponse, GetProviderTokenApiArg>({
            query: queryArg => ({ url: `/api/auth/token/${queryArg.providerName}/${queryArg.tokenName}` }),
        }),
        revokeProviderToken: build.mutation<RevokeProviderTokenApiResponse, RevokeProviderTokenApiArg>({
            query: queryArg => ({
                url: `/api/auth/revoke/${queryArg.providerName}/${queryArg.tokenName}`,
                method: 'POST',
            }),
        }),
        postUserExternalToken: build.mutation<PostUserExternalTokenApiResponse, PostUserExternalTokenApiArg>({
            query: () => ({ url: `/api/service/userToken/external`, method: 'POST' }),
        }),
        postUserInternalToken: build.mutation<PostUserInternalTokenApiResponse, PostUserInternalTokenApiArg>({
            query: queryArg => ({
                url: `/api/service/userToken/internal`,
                method: 'POST',
                body: queryArg.exchangeAccessTokenForInternalRequest,
            }),
        }),
        exchangeTokenForTicket: build.mutation<ExchangeTokenForTicketApiResponse, ExchangeTokenForTicketApiArg>({
            query: queryArg => ({
                url: `/api/kerberos/exchange`,
                method: 'POST',
                body: queryArg.kerberosExchangeRequest,
            }),
        }),
        exchangeToken: build.mutation<ExchangeTokenApiResponse, ExchangeTokenApiArg>({
            query: queryArg => ({ url: `/api/exchange`, method: 'POST', body: queryArg.exchangeRequest }),
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as expirioApi };
export type GetVersionApiResponse = /** status 200 OK */ string;
export type GetVersionApiArg = void;
export type ListSecretsApiResponse = /** status 200 OK */ ListSecretsResponse;
export type ListSecretsApiArg = void;
export type DeleteSecretApiResponse = unknown;
export type DeleteSecretApiArg = {
    secretName: string;
};
export type CreateTextSecretApiResponse = unknown;
export type CreateTextSecretApiArg = {
    addTextSecretRequest: AddTextSecretRequest;
};
export type ReadTextSecretApiResponse = unknown;
export type ReadTextSecretApiArg = {
    secretName: string;
};
export type CreateFileSecretApiResponse = unknown;
export type CreateFileSecretApiArg = {
    addFileSecretRequest: AddFileSecretRequest;
};
export type ReadFileSecretApiResponse = unknown;
export type ReadFileSecretApiArg = {
    secretName: string;
};
export type ReadProvidersApiResponse = /** status 200 OK */ undefined;
export type ReadProvidersApiArg = {
    /** Optional filter to return providers in a specific request state. */
    state?: EProviderRequestState;
};
export type GetAllProviderTokensApiResponse = /** status 200 OK */ undefined;
export type GetAllProviderTokensApiArg = void;
export type LoginProviderApiResponse = /** status 200 OK */ undefined;
export type LoginProviderApiArg = {
    providerName: string;
    tokenName: string;
    asRedirect?: boolean;
};
export type SetProviderTokenApiResponse = /** status 200 OK */ undefined;
export type SetProviderTokenApiArg = {
    setProviderTokenRequest: SetProviderTokenRequest;
};
export type GetProviderTokenApiResponse = /** status 200 OK */ undefined;
export type GetProviderTokenApiArg = {
    providerName: string;
    tokenName: string;
};
export type RevokeProviderTokenApiResponse = /** status 200 OK */ undefined;
export type RevokeProviderTokenApiArg = {
    providerName: string;
    tokenName: string;
};
export type PostUserExternalTokenApiResponse = /** status 200 OK */ undefined;
export type PostUserExternalTokenApiArg = void;
export type PostUserInternalTokenApiResponse = /** status 200 OK */ undefined;
export type PostUserInternalTokenApiArg = {
    exchangeAccessTokenForInternalRequest: ExchangeAccessTokenForInternalRequest;
};
export type ExchangeTokenForTicketApiResponse = /** status 200 OK */ ExchangeResponse;
export type ExchangeTokenForTicketApiArg = {
    kerberosExchangeRequest: KerberosExchangeRequest;
};
export type ExchangeTokenApiResponse = /** status 200 OK */ ExchangeResponse;
export type ExchangeTokenApiArg = {
    exchangeRequest: ExchangeRequest;
};
export type ListSecretsResponse = {
    secretNames: string[];
};
export type AddTextSecretRequest = {
    secretName: string;
    secretContent: any;
    expirationTime?: any;
};
export type IFormFile = Blob;
export type AddFileSecretRequest = {
    secretName: string;
    file: IFormFile;
    expirationTime?: any;
};
export type EProviderRequestState = number;
export type UserId = any;
export type SetProviderTokenRequest = {
    provider: string;
    accessToken: string;
    refreshToken: string;
    userId?: UserId;
};
export type ExchangeAccessTokenForInternalRequest = {
    accessToken: string;
    username?: any;
};
export type ExchangeResponse = {
    fileName: string;
    content: string;
    size: any;
    timestamp: string;
};
export type KerberosExchangeRequest = {
    providerName: string;
};
export type ExchangeRequest = {
    clientName: string;
    providerName: string;
};
export const {
    useGetVersionQuery,
    useListSecretsQuery,
    useDeleteSecretMutation,
    useCreateTextSecretMutation,
    useReadTextSecretQuery,
    useCreateFileSecretMutation,
    useReadFileSecretQuery,
    useReadProvidersQuery,
    useGetAllProviderTokensQuery,
    useLoginProviderQuery,
    useSetProviderTokenMutation,
    useGetProviderTokenQuery,
    useRevokeProviderTokenMutation,
    usePostUserExternalTokenMutation,
    usePostUserInternalTokenMutation,
    useExchangeTokenForTicketMutation,
    useExchangeTokenMutation,
} = injectedRtkApi;
